import axios from "axios";

const DEFAULT_API_HOST = "http://127.0.0.1:8000/api";

export const API_HOST = process.env.REACT_APP_API_HOST || DEFAULT_API_HOST;

export const secure = (token) => {
  return axios.create({
    baseURL: API_HOST,
    // timeout: 15000,
    headers: {
      Authorization: "Bearer " + token,
      contentType: "application/json",
    },
  });
};

export const unSecure = () => {
  return axios.create({
    baseURL: API_HOST,
    // timeout: 15000
  });
};
